import { AssetMediaFilterKey, AssetMediaFilterModel } from '../domain';
import { useFilter } from '../../filter';
import { useCurrentWorkspace } from '../../auth';

export const useAssetMediaFilter = (assetId: string) => {
  const currentWorkspace = useCurrentWorkspace();
  const workspace = currentWorkspace === null ? 'ME' : currentWorkspace?.id;

  return useFilter(
    `${AssetMediaFilterKey}-${assetId}`,
    'assetMediaFilter',
    (filter: string) => new AssetMediaFilterModel(filter),
    true,
    workspace ? `${workspace}__${assetId}` : assetId
  );
};
